import { metricsBus } from "@/common/buses";
import gaMetrics from "@/common/services/ga/gaMetrics";

metricsBus.on("gifView", (props) => {
  gaMetrics.sendGifView(props);
});

metricsBus.on("meaningfulGifView", (props) => {
  gaMetrics.sendMeaningfulGifView(props);
});

metricsBus.on("gifReplay", (props) => {
  gaMetrics.sendGifReplay(props);
});

metricsBus.on("uploadSelected", ({ type }) => {
  switch (type) {
  case "video":
    gaMetrics.sendUploadVideoSelected();
    break;
  case "image":
    gaMetrics.sendUploadImageSelected();
    break;
  case "bulkImages":
    gaMetrics.sendUploadBulkClick();
    break;
  case "url":
    gaMetrics.sendUploadUrlSelected();
    break;
  default:
    console.error(`[GA] Undefined upload type: ${type}`);
  }
});

metricsBus.on("uploadStarted", () => {
  gaMetrics.sendUploadStarted();
});

metricsBus.on("uploadTagSelectionEnded", () => {
  gaMetrics.sendUploadTagsSelected();
});

metricsBus.on("uploadEnded", () => {
  gaMetrics.sendUploadPublished();
});

metricsBus.on("gifClicked", (props) => {
  gaMetrics.sendGifClick(props);
});

metricsBus.on("gifLiked", (props) => {
  gaMetrics.sendLiked(props);
});

metricsBus.on("addedToCollection", (props) => {
  gaMetrics.sendAddedToCollection(props);
});

metricsBus.on("fullscreenEntered", () => {
  gaMetrics.sendEnterFullscreen();
});

metricsBus.on("adLoaded", (props) => {
  gaMetrics.sendAdLoaded(props);
});

metricsBus.on("infoBarClicked", () => {
  gaMetrics.sendInfobarCta();
});

metricsBus.on("infoBarClosed", () => {
  gaMetrics.sendInfobarDismiss();
});

metricsBus.on("sharedFixedEmbed", () => {
  gaMetrics.sendShareEmbedFixed();
});

metricsBus.on("sharedResponsiveEmbed", () => {
  gaMetrics.sendShareEmbedResponsive();
});

metricsBus.on("shareClick", () => {
  gaMetrics.sendShareClick();
});

metricsBus.on("shareCopy", () => {
  gaMetrics.sendShareCopy();
});

metricsBus.on("shareEmbed", () => {
  gaMetrics.sendShareEmbed();
});

metricsBus.on("shareTwitter", () => {
  gaMetrics.sendShareTwitter();
});

metricsBus.on("shareReddit", () => {
  gaMetrics.sendShareReddit();
});

metricsBus.on("shareDiscord", () => {
  gaMetrics.sendShareDiscord();
});

metricsBus.on("optionClicked", () => {
  gaMetrics.sendOptionClick();
});

metricsBus.on("pinnedContentClicked", () => {
  gaMetrics.sendPinnedContentClick();
});

metricsBus.on("PWASessionStarted", () => {
  gaMetrics.sendPWASessionStarted();
});

metricsBus.on("menuButtonClicked", (props) => {
  gaMetrics.sendMenuButtonClicked(props);
});

metricsBus.on("followUserClicked", (props) => {
  gaMetrics.sendFollowUserClicked(props);
});

metricsBus.on("socialProfileClicked", (props) => {
  gaMetrics.sendSocialProfileClick(props);
});

metricsBus.on("tagClicked", (props) => {
  gaMetrics.sendTagClicked(props);
});

metricsBus.on("signUpViewed", () => {
  gaMetrics.sendSignUpFormView();
});

metricsBus.on("signUpSuccess", () => {
  gaMetrics.sendSignUpSuccessful();
});

metricsBus.on("scrollPromptViewed", () => {
  gaMetrics.sendScrollPromptShow();
});

metricsBus.on("scrollPromptClosed", () => {
  gaMetrics.sendScrollPromptDismiss();
});

metricsBus.on("searched", (props) => {
  gaMetrics.sendSearch(props);
});

metricsBus.on("uploadVideoTrimmed", () => {
  gaMetrics.sendUploadVideoTrim();
});

metricsBus.on("uploadGetVerifiedClicked", () => {
  gaMetrics.sendUploadGetVerifiedClicked();
});

metricsBus.on("uploadSourceConfirmed", ({ type }) => {
  switch (type) {
  case "video":
    gaMetrics.sendUploadVideoConfirmed();
    break;
  case "image":
    gaMetrics.sendUploadImageConfirmed();
    break;
  case "multiple":
    gaMetrics.sendUploadMultipleConfirmed();
    break;
  default:
    console.error(`[GA] Undefined upload type: ${type}`);
  }
});

metricsBus.on("uploadAudienceDefined", () => {
  gaMetrics.sendUploadAudienceDefined();
});

metricsBus.on("uploadSourceDropped", ({ type }) => {
  switch (type) {
  case "video":
    gaMetrics.sendUploadVideoDropped();
    break;
  case "image":
    gaMetrics.sendUploadImageDropped();
    break;
  case "images":
    gaMetrics.sendUploadImagesDropped();
    break;
  default:
    console.error(`[GA] Undefined upload type: ${type}`);
  }
});

metricsBus.on("uploadFinished", (props) => {
  gaMetrics.sendUploadFinisher(props);
});

metricsBus.on("gifWatched120s", () => {
  gaMetrics.sendWatch120s();
});

metricsBus.on("profileViewed", (props) => {
  gaMetrics.sendProfileView(props);
});

metricsBus.on("errorLoadingGifs", () => {
  gaMetrics.sendErrorLoadingGifs();
});

metricsBus.on("voteUpAddClicked", () => {
  gaMetrics.sendVoteUpAddClick();
});

metricsBus.on("voteUpRemoveClicked", () => {
  gaMetrics.sendVoteUpRemoveClick();
});

metricsBus.on("voteDownAddClicked", () => {
  gaMetrics.sendVoteDownAddClick();
});

metricsBus.on("voteDownRemoveClicked", () => {
  gaMetrics.sendVoteDownRemoveClick();
});

metricsBus.on("privateSessionStarted", () => {
  gaMetrics.sendSessionStartPrivate();
});

metricsBus.on("tagFeedbackEnabledOptions", () => {
  gaMetrics.sendTagFeedbackEnabledOptions();
});

metricsBus.on("tagFeedbackEnabled", () => {
  gaMetrics.sendTagFeedbackEnabled();
});

metricsBus.on("playerNicheClicked", () => {
  gaMetrics.sendPlayerNicheClick();
});

metricsBus.on("playerTagClicked", () => {
  gaMetrics.sendPlayerTagClick();
});

metricsBus.on("verificationSubmit", () => {
  gaMetrics.sendVerificationSubmit();
});

metricsBus.on("orientationChanged", ({ type }) => {
  if (type.includes("landscape")) {
    gaMetrics.sendHorizontalOrientation();
  }

  if (type.includes("portrait")) {
    gaMetrics.sendVerticalOrientation();
  }
});

metricsBus.on("viewModeFeedChanged", (props) => {
  gaMetrics.sendViewModeFeedChanged(props);
});

metricsBus.on("nicheGifsOrderChanged", (props) => {
  gaMetrics.sendNicheGifsOrderChanged(props);
});
